import { LotteryConfigModel } from "../models/lottery-configuration-model";
import { Lottery } from "../../../models/lottery";

export const kasickaConfig: LotteryConfigModel = {
    lottery: Lottery.kasicka,
    boardCount: 1,
    primaryMinBoardSize: 3,
    primaryBoardSize: 5,
    defaultStake: 20,
    defaultStakeKasa: 20,
    primaryNumbers: 49,

    basePrice: 20,

    primarySystemMinCount: 3,
    primarySystemMaxCount: 16,

    boardLabel: "Sloupec",
    hasDurationComponent: true,
    multiplierOptions: [1, 2, 3, 5, 10, 15, 20, 50],
    hasDrawOptions: true,
    hasDurationInDays: true,
    hasMultidrawNotification: true,
    hasAllOrOneMultidrawOptions: false,
    hasSubscription: true,
    isDrawnEveryDay: true,
    durationTitle: "Kasičku losujeme <strong>2x denně.</strong>",
    durationTitleShort: "Kasičku losujeme 2x denně - ve 14:00 a 20:00.",
    maxDuration: 56,
    multidrawDurationOptions: [
        { value: "afternoon", valueKasa: "AFTERNOON", mainText: "Odpolední", hour: 14, drawName: "aft" },
        { value: "evening", valueKasa: "EVENING", mainText: "Večerní", hour: 20, drawName: "evn" },
    ],
    stakeOptions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25],
    hasCalculatedJackpot: false,
};
